type Params = { cost: number; marginRatio: number };

export const computeMarginPrice = ({ marginRatio, cost }: Params) => {
  return cost * (marginRatio / 100);
};
